<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Conversões Rastreadas</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span
                v-if="countFilter > 0"
                class="badge badge-light"
              >{{countFilter}}</span>
            </button>
            <b-button
              v-if="countFilter > 0"
              variant="primary"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </b-button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Clientes</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6
                  class="m-0"
                >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">{{labelName}}</th>
                    <th scope="col" class="border-0 text-left">Data do Cadastro</th>
                    <th scope="col" class="border-0 text-left">Origem</th>
                    
                    <th scope="col" class="border-0">Valor faturado</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(campaign, index) in merchantCampaigns" :key="index">
                    <td></td>
                    <td class="text-left td-with-subs">
                      <div>{{campaign.Merchant.Name | substring(50)}}</div>
                      <span>{{campaign.Merchant.Identity | identity }}</span>
                    </td>
                    

                    <td class="text-left">
                      <div>{{campaign.Merchant.CreatedDate  | date}}</div>
                      <span
                        class="td-span-style"
                      >{{campaign.Merchant.CreatedDate | date('HH:mm:ss') }}</span>
                    </td>

                    <td class="text-left td-with-subs">
                      <div>{{campaign.Merchant.AdditionalInformation.MktCampaign.utm_source}}</div>
                      <span>{{campaign.Merchant.AdditionalInformation.MktCampaign.utm_medium}}</span>
                    </td>

                    

                    <td>
                      <span class="badge badge-success">{{campaign.NoteExtract.Amount | currency}}</span>
                    </td>
                    <td></td>
                  </tr>
                  <tr
                    v-if="merchantCampaigns == undefined || merchantCampaigns == null || merchantCampaigns.length == 0"
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <date-field v-model="filter.EmissionDate" format="MMMM yyyy" minimumView="month"></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.Identifier" :value="null">
            <option :value="null" selected>Selecione a campanha</option>
            <option
              v-for="campaign in campaigns"
              v-bind:value="campaign.Identifier"
              v-bind:key="campaign.Identifier"
            >{{campaign.Description}}</option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "merchant-campaigns",
  components: {
    dateField
  },
  data: function() {
    return {
      loadingList: false,
      countFilter: 1,
      labelName: "Cliente",
      labelIdentity: "CPF/CNPJ",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      filter: {
        Name: null,
        Identity: null,
        Identifier: null,
        EmissionDate: this.$options.filters.date(new Date(), "YYYY-MM-DD")
      },
      campaigns: [],
      merchantCampaigns: []
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListCampaignMerchant();
    },
    "pagination.RowsPerPage": function() {
      this.ListCampaignMerchant();
    }
  },
  mounted() {
    this.ListCampaignMerchant();
    this.ListCampaign();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListCampaignMerchant();
    },
    ListCampaignMerchant: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.Identifier)) this.countFilter++;
      if (hasValue(this.filter.EmissionDate)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Merchant.Name": this.filter.Name,
          "Object.Merchant.Identity": this.filter.Identity,
          "Object.Identifier": this.filter.Identifier,
          "Object.NoteExtract.EmissionDate": this.filter.EmissionDate
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListCampaignMerchant", { params: data })
        .then(response => {
          this.merchantCampaigns = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os clientes",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ListCampaign: function() {
      this.$store
        .dispatch("ListCampaign", {})
        .then(response => {
          this.campaigns = response.Objects;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as campanhas",
            error
          );
        });
    },
    ResetFilter: function() {
      this.filter = {
        Name: null,
        Identity: null,
        Identifier: null,
        EmissionDate: this.$options.filters.date(new Date(), "YYYY-MM-DD")
      };
      this.ListCampaignMerchant();
    }
  }
};
</script>

<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 10pt;
  opacity: 0.75;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/merchantCampaigns.vue